export default __webpack_public_path__ + "images/logoBusinessInsider.6a6d91c65493bf55b3e4928bfd1b9f18.svg"